import { gql } from '@apollo/client';

export const CONFIRM_PLAYER_ENTRY = gql`
    mutation confirmPlayerEntry($token: String!, $pin: String!) {
        confirmPlayerEntry(token: $token, pin: $pin) {
            _id
            first_name
            last_name
            email
            entry_at
            confirmed
            sub_event_name
            event_name
            tracking_number
            emp_player_url
        }
    }
`;

export const TOGGLE_EVENT_ACCESS_MANAGEMENT = gql`
    mutation toggleEventAccessManagement($event_id: String!, $enabled: Boolean!) {
        toggleEventAccessManagement(event_id: $event_id, enabled: $enabled)
    }
`;

export const TOGGLE_SUB_EVENT_ACCESS_MANAGEMENT = gql`
    mutation toggleSubEventAccessManagement($sub_event_id: String!, $enabled: Boolean!) {
        toggleSubEventAccessManagement(sub_event_id: $sub_event_id, enabled: $enabled)
    }
`;

export const RESET_EVENT_ACCESS_PIN = gql`
    mutation resetEventAccessPin($event_id: String!) {
        resetEventAccessPin(event_id: $event_id)
    }
`;
